const i18n_fields = {
  EN: [
    { key: 'id', label: 'No.', sortable: true, thStyle: 'width: 5%' },
    { key: 'agent', label: 'Agent', sortable: true, thStyle: 'width: 30%' },
    { key: 'scan_folder', label: 'Check Folder', sortable: true },
    { key: 'scan_count', label: 'Check File', sortable: true },
    { key: 'detect_count', label: 'Detect Count', sortable: true },
    { key: 'scan_time', label: 'Check Time', sortable: true },
  ],
  KO: [
    { key: 'id', label: 'No.', sortable: true, thStyle: 'width: 5%' },
    { key: 'agent', label: '에이전트', sortable: true, thStyle: 'width: 30%' },
    { key: 'scan_folder', label: '점검 폴더', sortable: true },
    { key: 'scan_count', label: '점검 파일', sortable: true },
    { key: 'detect_count', label: '탐지 수', sortable: true },
    { key: 'scan_time', label: '점검 일시', sortable: true },
    // { key: 'func', label: '더 보기', sortable: false, thStyle: 'width: 10%'  },
  ],
  JP : [
    { key: 'id', label: 'No.', sortable: true, thStyle: 'width: 5%' },
    { key: 'agent', label: 'エージェント', sortable: true, thStyle: 'width: 30%' },
    { key: 'scan_folder', label: 'フォルダーを確認', sortable: true },
    { key: 'scan_count', label: 'ファイルを確認', sortable: true },
    { key: 'detect_count', label: '検出数', sortable: true },
    { key: 'scan_time', label: '時間を確認', sortable: true },
    // { key: 'func', label: 'More', sortable: false, thStyle: 'width: 10%'  },
  ]
}

const i18n_toastr = { i18n_fields }

export default i18n_toastr